export const colors = {
  white: '#ffffff',
  gray: {
    100: '#d8d8d8',
    200: '#ebe9d7',
    300: '#b5b4b4',
    400: '#8d8c8c',
    500: '#0000008a',
    600: '#38374380',
    700: '#494758',
    800: '#383743',
    900: '#403e4d',
  },

  blue: {
    200: '#748383',
    500: '#57bbbc',
    800: '#0d0430',
  },
  indigo: {
    800: '#1a0e49',
  },
  red: {
    500: '#ff0f44',
    800: '#991237',
  },
  pink: {
    500: '#ee4c77',
  },
  green: {
    500: '#7dc075',
  },
};
